import { RoleCategories } from '../../application/common/constants/role-categories';
import { useAppSelector } from '../../application/store/useStore';
/**
 * Custom hook to combine currentUser and currentCompany selectors.
 * companyId will be undefined for SuperAdmin role category.
 * @returns An object containing current users session information.
 */
var useCurrentUser = function () {
    var _a;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var userId = currentUser.userId;
    var primaryCompanyId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.primaryCompanyId;
    var roleCategory = currentUser.roleCategory;
    var companyId = roleCategory === RoleCategories.Others
        ? (_a = currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id) !== null && _a !== void 0 ? _a : currentUser === null || currentUser === void 0 ? void 0 : currentUser.primaryCompanyId
        : undefined;
    return { userId: userId, companyId: companyId, roleCategory: roleCategory, primaryCompanyId: primaryCompanyId };
};
export default useCurrentUser;
